import { Component } from '@angular/core';
import { AuthService } from './RoutingAuth/auth.service';
import { ConfigService } from './Services/ConfigService';

@Component({
	selector: 'app-root',
	templateUrl: './app.component.html',
	
})
export class AppComponent {

	constructor(
		private configData: ConfigService,
		private myAuthService: AuthService,

	) {
		this.myAuthService.authNavStatus$.subscribe(isAuthed => {
			this.isSuperAdmin = this.configData.isSuperAdmin();
			this.isAuthenticated = isAuthed;
		});
		this.isAuthenticated = this.myAuthService.isAuthenticated();
	}


	isAuthenticated: boolean = false;
	isSuperAdmin: boolean = this.configData.isSuperAdmin();



}
